import React from 'react';

export const SpacerVertical = ({ width }) => {
    return <div style={{ width: width }} />
};

export const SpacerHorizontal = ({ height }) => {
    return <div style={{ height: height }} />
};